export const handleResizeComponent = (puzzleGrid,setCellWidth,rows,cols,scrollVisible,isVerticalScreen) => ()=> {

    if(puzzleGrid && puzzleGrid.current){

        const cellWidth = getCellWidth(puzzleGrid,rows,cols,scrollVisible,isVerticalScreen);

        //console.log('puzzle-grid width',puzzleWidth);

        //const puzzleWidth = puzzleGrid.current.clientWidth;

        //console.log('puzzle-grid width resize',puzzleWidth);

        //setCellWidth(32);
        //console.log('set width change',cellWidth);
        setCellWidth(cellWidth);
           

    }

}

const getCellWidth = (puzzleGrid,rows,cols,scrollVisible,isVerticalScreen)=>{
       
    const puzzleGridDom = puzzleGrid.current;
    //const puzzleClues = puzzleGridDom.nextSibling;
    const puzzleContainer = puzzleGridDom.parentElement;
    const puzzleGameContainer = puzzleContainer.parentElement;
    //const puzzleGameHeader = puzzleContainer.previousSibling;

    //let puzzleHeight = puzzleGameContainer.clientHeight - 
    //    puzzleGameHeader.clientHeight - 32 - (scrollVisible ? 1 : 0) * 168;

    if(!isVerticalScreen){

        let puzzleHeight = puzzleGameContainer.clientHeight - puzzleContainer.offsetTop - 24;

        //console.log('is vertical',isVerticalScreen);

        let h1 = Math.floor(puzzleHeight / rows);

        return h1;

    }else{

        let puzzleWidth = puzzleContainer.clientWidth - 8;

        let w1 = Math.floor(puzzleWidth / cols);

        return w1;

    }    
    

    //let puzzleWidth = puzzleContainer.clientWidth - puzzleClues.clientWidth - 180;

    //let puzzleWidth = isVerticalScreen ? puzzleContainer.clientWidth: puzzleContainer.clientWidth * 2 / 3;

    //console.log(puzzleClues.clientWidth);
    //if(!isVerticalScreen && puzzleWidth + puzzleClues.clientWidth > puzzleContainer.clientWidth){
    //    puzzleWidth = puzzleContainer.clientWidth - puzzleClues.clientWidth - 80;
    //}
 
   /*  if(puzzleGridDom.clientWidth + 16 === puzzleContainer.clientWidth){

        puzzleWidth = puzzleContainer.clientWidth - 24;
        //puzzleWidth= puzzleContainer.clientWidth;

    }        

    let h = Math.floor(puzzleHeight / rows);

    let w = Math.floor(puzzleWidth / cols);

    if(isVerticalScreen){
        return w;
    }else{
        return h < w ? h : w;        
    } */

    

    

    //w = w > 64 ? 64 : w;

    //w = w < 32 ? 32 : w ;

    //console.log(resp);

    //return w;
};
